import { render, staticRenderFns } from "./Invalid.vue?vue&type=template&id=cb920b92&scoped=true&"
import script from "./Invalid.vue?vue&type=script&lang=js&"
export * from "./Invalid.vue?vue&type=script&lang=js&"
import style0 from "./Invalid.vue?vue&type=style&index=0&id=cb920b92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb920b92",
  null
  
)

export default component.exports